import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import cx from "classnames";

import t from "utils/translate";
import SiteWrapper from "../SiteWrapper";
import ContentGutter from "../ContentGutter";
import useAppContext from "../AppContext";
import routes from "../../routes";
import { getSequenceRedirectUrl } from "utils/sequence";
import { logger } from "utils/logger";
import { getClinicTabData } from "utils/getClinicTabData";

import styles from "./styles.module.scss";

export default function ProgressBar({
  question,
  backButtonProps,
  withProgressBar
}) {
  const { newQuiz } = useAppContext();
  const { sectionIndex, sectionTotal, section } = question;
  const { questionNumber, totalQuestionsInSection } =
    question.newQuizSectionsInfo;
  const { onBack, ...otherBackProps } = backButtonProps || false;
  const backButtonRef = useRef(null);
  const history = useHistory();
  const { isFromClinicTab, closeRedirectUrl } = getClinicTabData();

  let progressArr = [];

  for (let i = 0; i < sectionTotal; i++) {
    if (i < sectionIndex) {
      progressArr.push({ progress: 1 });
    } else if (i === sectionIndex) {
      let progress = questionNumber / totalQuestionsInSection;
      progressArr.push({ progress: progress });
    } else {
      progressArr.push({ progress: 0 });
    }
  }

  // On the state question, remove the back button.
  const onStateQuestion =
    history.location.pathname === routes.state &&
    (newQuiz.isUni3 || newQuiz.isUni4);

  const onClose = async url => {
    if (url) {
      window.location.href = url;
    } else {
      try {
        const res = await getSequenceRedirectUrl();
        const { redirect } = res.data;
        if (redirect) {
          window.location.href = redirect;
        }
      } catch (error) {
        logger("Error getting sequence redirect URL", {
          level: "error",
          customAttributes: { error }
        });
      }
    }
  };

  useEffect(() => {
    if (backButtonRef.current) {
      backButtonRef.current.blur();
    }
  }, [onBack]);

  return (
    <ContentGutter>
      <SiteWrapper size="small">
        <div className={styles.controls}>
          {onBack && !onStateQuestion && (
            <button
              ref={backButtonRef}
              tabIndex={0}
              onClick={() => onBack()}
              className={cx({
                [styles.stickyBackAndroid]: newQuiz.isAndroid,
                [styles.backButton]: !newQuiz.isClinical,
                [styles.backButtonClinical]: newQuiz.isClinical
              })}
              {...otherBackProps}
            >
              <span className={styles.hidden}>{t("NAVIGATE_BACK")}</span>
            </button>
          )}
          {isFromClinicTab && newQuiz.isClinical && (
            <button
              type="button"
              className={styles.close}
              onClick={() => onClose(closeRedirectUrl)}
            >
              <span className={styles.hidden}>{t("CLOSE")}</span>
            </button>
          )}
        </div>
        {withProgressBar && (
          <>
            <div className={styles.wrapper}>
              <div className={styles.tag}>{section?.replace(/_/g, " ")}</div>
              <div className={styles.progressBarWrapper}>
                {progressArr.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <progress
                        className={styles.progressBar}
                        value={item.progress}
                        max="1"
                      ></progress>
                      <label
                        htmlFor={`progressBar${index}`}
                        className={styles.srOnly}
                      >
                        Progress of section {index + 1}:{" "}
                        {Math.round(item.progress * 100)}%
                      </label>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
            <div className={styles.logo}></div>
          </>
        )}
      </SiteWrapper>
    </ContentGutter>
  );
}
